module.exports = __webpack_public_path__ + "img/13.bdbbc610.png";